import { styled } from 'styled-components';
import { Container } from '@design-system/container';
export const TitleContainer = styled(Container).attrs(() => ({
    justifyContent: 'start',
    px: {
        l: 8,
        m: 6,
        s: 4,
    },
    py: 4,
})) ``;
//# sourceMappingURL=TitleContainer.js.map